import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import DropDownTreeViewViewModelType from '@/ViewModels/Controls/DropDownTreeViewViewModel';
import CoreFrameDropDownTreeViewType from '@/Controls/CoreFrameDropDownTreeView';

export default class DropDownTreeView extends Control {

    private CoreFrameDropDownTreeView = ComponentManager.getControl<typeof CoreFrameDropDownTreeViewType>('CoreFrameDropDownTreeView');
    private jQueryControl: JQuery;
    private coreFrameDropDownTreeView: CoreFrameDropDownTreeViewType;

    public constructor(private viewModel: DropDownTreeViewViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null)
            return this.jQueryControl;

        // TODO: Hier wird ein falsches ViewModel übergeben?
        this.coreFrameDropDownTreeView = new this.CoreFrameDropDownTreeView(this.viewModel.coreFrameDropDownTreeViewViewModel);
        this.jQueryControl = this.coreFrameDropDownTreeView.getControl();

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('DropDownTreeView', DropDownTreeView, 'RADPresentation.HTMLClient.DefaultViewExtensions');